import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DashboardPageRoutingModule } from './dashboard-routing.module';

import { DashboardPage } from './dashboard.page';
import { AutocompleteModule } from 'src/app/components/autocomplete/autocomplete.module';
import { PendingListSkeletonModule } from 'src/app/components/pending-list-skeleton/pending-list-skeleton.module';
import { QuoteCardModule } from 'src/app/components/quote-card/quote-card.module';
import { RecommendationCardModule } from 'src/app/components/recommendation-card/recommendation-card.module';
import { DashboardUserItemSummaryModule } from 'src/app/components/dashboard-user-item-summary/dashboard-user-item-summary.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DashboardPageRoutingModule,
    ReactiveFormsModule,
    AutocompleteModule,
    PendingListSkeletonModule,
    QuoteCardModule,
    RecommendationCardModule,
    DashboardUserItemSummaryModule
  ],
  declarations: [DashboardPage]
})
export class DashboardPageModule {}
